import { TableUIProvider } from "../../contexts/TableUIContext";
import Subscribers from "./Subscribers";

export default function SubscribersWrapper() {
    return (
        <TableUIProvider>
            <Subscribers />
        </TableUIProvider>
    );
}
